import React, { Component } from "react";
import {
    Button, Modal, ModalBody, ModalHeader
} from "reactstrap";
import Registry from "../../../Utils/Registry";
import EnterpriseCoworkersListItem from "./CoworkersItem";
import EnterpriseCoworkersBaseForm from "./BaseForm";
import {NotificationManager} from "react-notifications";


class EnterpriseCoworkersList extends Component{
    constructor(props){
        super(props);

        this.user = Registry.observe(this, "user", user => {
            this.user = user;
            this.loadData();
        });

        this.api = Registry.registered("api");

        this.loadData = this.loadData.bind(this);
        this.notify = this.notify.bind(this);
        this.toggleAddCoworkers = this.toggleAddCoworkers.bind(this);
        this.onCustomerInvited = this.onCustomerInvited.bind(this);

        this.state = {
            loading: false,
            coworkers: [],
            add_coworkers_shown: false
        };
    }

    componentDidMount(){
        this.loadData();
    }

    notify(msg, type="success", timeout=5000){
        switch (type){
            case "info":
                NotificationManager.info(msg);
                break;
            case "success":
                NotificationManager.success(msg);
                break;
            case "warning":
                NotificationManager.warning(msg);
                break;
            case "error":
                NotificationManager.error(msg);
                break;
            default:
                break;
        }
    }

    loadData(){
        if(this.user){
            this.setState({loading: true});
            this.api.get("/business/coworkers")
                .then(results => {
                    let coworkers = [];
                    let you = null;
                    for(let co of results.coworkers){
                        if(co.id != this.user.id)
                            coworkers.push(co);
                        else
                            you = co;
                    }
                    if(you)
                        coworkers.unshift(you);
                    this.setState({
                        coworkers: coworkers,
                        loading: false
                    });
                })
                .catch(error => {
                    this.setState({loading: false});
                });
        }
    }

    toggleAddCoworkers(){
        this.setState({add_coworkers_shown: !this.state.add_coworkers_shown});
    }

    onCustomerInvited(){
        setTimeout(this.toggleAddCoworkers, 500);
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-between pad-b-10">
                    <h2 className="ty-subtitle">Vos collaborateurs</h2>

                    <div>
                        <Button color="primary" className="text-uppercase btn-xs" onClick={this.toggleAddCoworkers}>
                            <i className="icon icon-plus marg-r-10"> </i> Ajouter
                        </Button>
                    </div>
                </div>

                <div className="ty-block">
                    {
                        this.state.loading ?
                            <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20" />
                            </div>
                            :
                            this.state.coworkers.map((worker, i) => {
                                return <EnterpriseCoworkersListItem
                                    actual_user_id={this.user.id}
                                    key={i}
                                    worker={worker}
                                    onUpdate={this.loadData}
                                    onNotify={this.notify}
                                />
                            })
                    }
                </div>

                <Modal isOpen={this.state.add_coworkers_shown} toggle={this.toggleAddCoworkers}>
                    <ModalHeader toggle={this.toggleAddCoworkers}>Ajouter un collaborateur</ModalHeader>
                    <ModalBody>
                        <EnterpriseCoworkersBaseForm onCustomerInvited={this.onCustomerInvited} />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

EnterpriseCoworkersList.defaultProps = {

};

export default EnterpriseCoworkersList;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Coworkers/CoworkersList.js